/* Copyright (c) 2020-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import axios from "axios";
import { createBrowserHistory } from "history";
import { handleSessionExpired, useRefreshToken } from "~/tools";

const client = axios.create({ baseURL: process.env.REACT_APP_ENDPOINT ?? "" });
const history = createBrowserHistory({ forceRefresh: true });

client.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response.status === 401) {
      handleSessionExpired();
    }
    if (
      error.response.status === 503 &&
      error.response.headers["x-maintenance"] === "true"
    ) {
      history.push("/maintenance");
    }

    return Promise.reject(error);
  }
);

export const useAxios = () => {
  const { refreshToken } = useRefreshToken();
  refreshToken();

  const Axios = React.useCallback(() => {
    const token = localStorage.getItem("token");
    const defaultOptions = {
      headers: {
        Authorization: token,
      },
    };

    return {
      post: (url: string, data?: unknown) => {
        return client.post(url, data, { ...defaultOptions });
      },
      get: (url: string, params: any = undefined) => {
        return client.get(url, { ...defaultOptions, params: params });
      },
      put: (url: string, data?: unknown) => {
        return client.put(url, data, { ...defaultOptions });
      },
      patch: (url: string, data?: unknown) => {
        return client.patch(url, data, { ...defaultOptions });
      },
      delete: (url: string) => {
        return client.delete(url, { ...defaultOptions });
      },
    };
  }, []);

  return { Axios };
};
